import superagent from "superagent";
import { authorize } from "../../helper/authorize-token";

export const updateWlfFee = async (token, wlfId, updates) => {
    const response = await superagent
        .post('/api/dashboard/wlf')
        .send({ wlfId, updates })
        .use(authorize(token));
    
    return response.body;
}